import { EUSignAlias, EUSignCPModuleInitialize } from './euscp/euscpm'
import { logger } from './logger';
import { webConfig } from '../constants/web-config.js';
import * as cnst from './euscp/euscpt.js';
import * as IEUSignCP_SW from './eusw/eusw.umd';
//import { promisePostSimple } from '../actions/fetch.js';

/*
 <!-- for global variant, scripts can be included to index in following order: -->
 <!-- script src="euutils.js"></script -->
 <!-- script src="euscpt.js"></script -->
 <!-- script src="euscpm.js"></script -->
 <!-- script src="euscp.js"></script -->
*/

class NdipitSign {

    base64Encode(byteArray) {
        return this.euSign.Base64Encode(byteArray);
    }

    setCAServersList(groupedList, currentServer) {
        logger.debugLog('setCAServersList:', groupedList, currentServer);
        this.CAServers = groupedList;
        this.currentCAServer = currentServer;

        this._saveUserLocalSetting(this.storeKeys.CAServerIndex, this.currentCAServer ? this.currentCAServer.id : null);

        let CAs = this.CAServers;

        let settings = this.euSign.CreateOCSPAccessInfoSettings();
        if (CAs && CAs.length > 0) { //strange logic - copy pasted from IIT example - not needed?
            for (let i = 0; i < CAs.length; i++) {
                settings.SetAddress(CAs[i].ocspAccessPointAddress);
                settings.SetPort(CAs[i].ocspAccessPointPort);

                for (let j = 0; j < CAs[i].issuerCNs.length; j++) {
                    settings.SetIssuerCN(CAs[i].issuerCNs[j]);
                    this.euSign.SetOCSPAccessInfoSettings(settings);
                }
            }
        }
        else {
            this.euSign.SetOCSPAccessInfoSettings(settings);
        }
    }

    init() {
        //logger.debugLog("NdipitSign init called. EUSignCryptoModule: ", self.EUSignCryptoModule);

        if (!this.EUSignCryptoModule) {
            logger.debugLog("NdipitSign init - EUSign library not loaded yet! Waiting...");
            setTimeout(() => { this.init(); }, 1000);
            return;
        }
        logger.debugLog("NdipitSign init - EUSign library isInited: ", this.euSign.IsInitialized());
        let res = this.euSign.Initialize();

        if (res != 0) {
            logger.errorLog("Error initing EUSign library!", res);
            return;
        }

        this.euSign.SetJavaStringCompliant(true);
        // для криптоканала понадобилось именно UTF-8, но видимо подписи всегда делаются в UTF-16LE?
        // чтобы не ломать, меняю только там, где нужно и тут же обратно
        this.euSign.SetCharset("UTF-16LE");
        //this.euSign.SetCharset("UTF-8");

        if (this.euSign.DoesNeedSetSettings())
            this.setDefaultEUSignSettings();

        if (!this._loadCertificatesFromSessionStorage())
            return;
        
        //this.prepareCryptSession(); // вызывается из действий снаружи

        this.isReady = true;
        logger.debugLog("NdipitSign init OK.");

        if (this.testMode) {
            this.testEngine();
        }
    }

    setDefaultEUSignSettings() {
        try {
            this.euSign.SetXMLHTTPProxyService(this.CARequestsProxy);

            var settings = this.euSign.CreateFileStoreSettings();
            settings.SetPath("/certificates");
            settings.SetSaveLoadedCerts(true);
            this.euSign.SetFileStoreSettings(settings);

            settings = this.euSign.CreateProxySettings();
            this.euSign.SetProxySettings(settings);

            settings = this.euSign.CreateTSPSettings();
            this.euSign.SetTSPSettings(settings);

            settings = this.euSign.CreateOCSPSettings();
            this.euSign.SetOCSPSettings(settings);

            settings = this.euSign.CreateCMPSettings();
            this.euSign.SetCMPSettings(settings);

            settings = this.euSign.CreateLDAPSettings();
            this.euSign.SetLDAPSettings(settings);

            settings = this.euSign.CreateOCSPAccessInfoModeSettings();
            settings.SetEnabled(true);
            this.euSign.SetOCSPAccessInfoModeSettings(settings);

            var CAs = this.CAServers
            settings = this.euSign.CreateOCSPAccessInfoSettings();
            if (CAs) {
                //strange logic - copy pasted from IIT example - not needed?
                for (var i = 0; i < CAs.length; i++) {
                    settings.SetAddress(CAs[i].ocspAccessPointAddress);
                    settings.SetPort(CAs[i].ocspAccessPointPort);

                    for (var j = 0; j < CAs[i].issuerCNs.length; j++) {
                        settings.SetIssuerCN(CAs[i].issuerCNs[j]);
                        this.euSign.SetOCSPAccessInfoSettings(settings);
                    }
                }
            }
            logger.debugLog("Eusign default settings set.");
        } catch (e) {
            logger.errorLog("Exception setting eusign default settings!", e);
            this.alert('Виникла помилка при встановленні налашувань крипто-бібліотеки!');
        }
    }

    _loadCertificatesFromSessionStorage() {
        var certificates = this._getSessionStorageItem(
            'CACertificates', true, false);
        if (certificates != null) {
            try {
                this.euSign.SaveCertificates(certificates);
                this.loadedRootCerts = true;
                return true;
            } catch (e) {
                logger.errorLog("Виникла помилка при імпорті " +
                    "завантажених з сервера сертифікатів " +
                    "до файлового сховища", e);
                return false;
            }
        }
        return true;
    }

    async loadRootCertificates(certificates) {
        try {
            this.euSign.SaveCertificates(certificates);
            this._setSessionStorageItem('CACertificates',
                certificates, false);
            this.loadedRootCerts = true;
            // и для хардварной, если надо
            if (this.isInitSW) {
                await this._SW_promiseApply(this.euSignSW.SaveCertificates, [certificates]);
            }
        } catch (e) {
            logger.errorLog("Exception setting certificates!", e);
            return false;
        }
        return true;
    }

    // похожая функа LoadFile есть в euutils.js, но там неудобные колбеки
    BlobToUint8Array(blob) {
        return new Promise((res) => {
            var fr = new FileReader();
            fr.onload = event => {
                const data = new Uint8Array(event.target.result);
                res(data);
            };
            fr.readAsArrayBuffer(blob);
        });
    }

    async prepareCryptSession(envelopCertificateBlob) {
        //this.request(redirectConfig.signlib.getServerCaCert)
        const envelopCertBytes = await this.BlobToUint8Array(envelopCertificateBlob);
        this.euSign.SaveCertificate(envelopCertBytes);
        const certInfo = this.euSign.ParseCertificate(envelopCertBytes);

        //можно не тянуть тестовый цск в корневые сертификаты, а задать эти параметры для подтверждения сертификата
        const ocspSettings = this.euSign.CreateOCSPSettings();
        ocspSettings.SetUseOCSP(true);
        //ocspSettings.SetBeforeStore(true);
        ocspSettings.SetAddress(webConfig.keyExchangeCertOcspAddress);
        ocspSettings.SetPort(webConfig.keyExchangeCertOcspPort);
        this.euSign.SetOCSPSettings(ocspSettings);

        //эксперименты показывают, что когда заканчивается sessionExpireTime, то ничего не меняется. Не знаю, зачем он нужен, пусть будет 8 часов
        this._clientSession = this.euSign.ClientDynamicKeySessionCreate(8*60*60/*sessionExpireTime*/, certInfo.issuer, certInfo.serial);
        //this._clientSession = this.euSign.ClientDynamicKeySessionCreate(8*60*60/*sessionExpireTime*/, envelopCertBytes);
        
        //Сохраняем сессию в session storage
        let sessionSerializeBuffer = this.euSign.SessionSave(this._clientSession);
        window.sessionStorage.setItem('clientSession', sessionSerializeBuffer);
        //и clientSessionData в sessionStorage (метод SessionSave этого не делает)
        let sessDataBuffer = this._clientSession.GetData();
        this._clientSessionData = this.euSign.Base64Encode(sessDataBuffer);
        window.sessionStorage.setItem('clientSessionData', sessDataBuffer);
    }

    sessionEncrypt(data, clientSession) {
        return this.euSign.SessionEncrypt(clientSession, data, false/*asBase64String*/)
    }

    sessionDecrypt(data, clientSession) {
        return this.euSign.SessionDecrypt(clientSession, data);
    }

    Uint8ArrayToString(data) {
        // у нас всегда подписи делаются в UTF-16LE (я не знаю, кто так решил, но поздно ломать), так что извращаемся
        // поскольку в беке зашифровывается на самом деле UTF-8
        this.euSign.SetCharset("UTF-8");
        const str = this.euSign.ArrayToString(data);
        this.euSign.SetCharset("UTF-16LE");
        return str;
    }

    getClientSessionFromStorage() {
        return new Promise(resolve => {
            let i = 0;
            const _waitForSessionStorage = () => {
                const savedSession = sessionStorage.getItem('clientSession');
                if (savedSession) {
                    resolve(savedSession);
                    return;
                }
                if (i > 100) {
                    //безнадёга, таймаут = 100*30 = 3 сек
                    resolve(null);
                    return;
                }
                if (i % 20 == 0) // каждые 20*30 = 0.6 сек
                    logger.debugLog("waiting for possible sessionStorage from another Tab...");
                setTimeout(_waitForSessionStorage, 30);
                i++;
            }
            _waitForSessionStorage();
        });
    }

    //Получить информацию о сессии (clientSession + clientSessionData)
    //Везде извне необходимо использовать эту функцию а не соответствующие проперти
    getClientSessionInfo() {
        return new Promise(async resolve => {
            if (this._clientSession) {
                resolve({
                    clientSession: this._clientSession,
                    clientSessionData: this._clientSessionData
                });
                return;
            }
            //Если нет данных о сессии - пытаемся их достать из sessionStorage
            //с ожиданием получения из другого таба, во время чего происходит обрабтока событий страницы при включённом тогглере
            const savedSession = await this.getClientSessionFromStorage();
            if (savedSession) {
                const buff = savedSession.split(',');
                let buffUint8 = new Uint8Array(buff.length);
                buff.forEach((item, i) => buffUint8[i] = item);

                const savedSessionData = sessionStorage.getItem('clientSessionData'),
                    buffSessionData = savedSessionData ? savedSessionData.split(',') : [];
                let buffSessionDataUint8 = new Uint8Array(buffSessionData.length);
                buffSessionData.forEach((item, i) => buffSessionDataUint8[i] = item);
                
                //Инициализация криптолибы происходит в конструкторе на load скрипта с либой
                //поэтому в момент выполнения данного кода при рефреше страницы ещё нет euSign
                //Поэтому ждём появления euSign через такой механизм
                const _waitForEuSign = () => {
                    if (!this.euSign) {
                        logger.debugLog("waiting for load EUSign library...");
                        setTimeout(_waitForEuSign, 1000);
                        return;
                    }
                    this._clientSession = this.euSign.SessionLoad(buffUint8);
                    this._clientSession.SetData(buffSessionDataUint8);
                    this._clientSessionData = this.euSign.Base64Encode(this._clientSession.GetData());
                    resolve({
                        clientSession: this._clientSession,
                        clientSessionData: this._clientSessionData
                    });
                };
                _waitForEuSign();
            } else {
                // не похоже, чтобы они были в других вкладках, это приведёт выше к разлогину
                resolve({
                    clientSession: null,
                    clientSessionData: null
                });
            }
        });
    }

    constructor(options) {
        logger.debugLog("NdipitSign constructor called.", options);
        this.CARequestsProxy = options.CARequestsProxy;

        this.loadedRootCerts = false;

        this.CAServers = options.CAServers || [];
        this.currentCAServer = null;

        this.offline = false; //do CA TSP etc servers requests
        this.useCMP = true; //use CA server to get cert, instead of file


        this.isUseSW = false; //использовать ли либу для аппаратных ключей
        this.euSignSW = null;

        options = options || {};

        this.storeKeys = options.storeKeys || {
            CAServerIndex: 'ndipit_cas'
        };

        this.isReady = false;
        this.isError = false;
        this.pkSet = false;
        this.testMode = options.testMode || false;
        this.useGlobalEusignWrapper = options.useGlobalEusignWrapper || false;

        //set options and defaults
        this.alert = options.alertFunc || function (msg) { window.alert(msg); }


        var self = this;

        var continueInit = function () {
            self.EUSignCryptoModule = Module;

            //this.utils = Utils(self.euSign);

            if (typeof EUSignCP !== 'undefined') {
                logger.debugLog('EUSignCP is GLOBAL!');

                //expandModule(Module);

                EUSignCPModuleInitialize(function () {
                    self.euSign = EUSignCP();
                    self.init();
                });
            }
            else {
                logger.debugLog('EUSignCP is local.');
                EUSignCPModuleInitialize(function () {
                    self.euSign = EUSignAlias();
                    self.init();
                });
            }
        }

        //load main huge file with globals and emscripten-transpiled part
        var tag = document.createElement("script");
        tag.src = options.coreEusignUrl;
        tag.async = false;
        document.getElementsByTagName("head")[0].appendChild(tag);

        tag.addEventListener('load', function () {
            logger.debugLog('Main Lib script loaded.');

            if (self.useGlobalEusignWrapper) {
                //load IIT wrapper around the library
                var tag1 = document.createElement("script");
                tag1.src = options.wrapperEusignUrl;
                tag1.async = false;
                document.getElementsByTagName("head")[0].appendChild(tag1);

                tag1.addEventListener('load', function () {
                    logger.debugLog('Lib wrapper script loaded.');
                    continueInit();
                });
            }
            else
                continueInit();
        });

        logger.debugLog("NdipitSign constructor finished.");
    }

    isSeal(certInfo) {
        let usg = certInfo.GetExtKeyUsages();
        logger.debugLog('Перевірка додаткових атрибутів (ExtKeyUsages):', usg);
        // 1.2.804.2.1.1.1.3.9 иит преобразовывает в Цифрова печатка
        // это именно то, что нам нужно согласно https://zakon.rada.gov.ua/laws/show/z1399-12
        return (usg && usg.match(/Цифрова печатка/));
    }

    activateCurrentCAServer() {
        var settings = this.euSign.CreateTSPSettings();
        if (!this.offline) {
            settings.SetGetStamps(true);
            if (this.currentCAServer.tspAddress != "") {
                settings.SetAddress(this.currentCAServer.tspAddress);
                settings.SetPort(this.currentCAServer.tspAddressPort);
            } else {
                settings.SetAddress('acskidd.gov.ua');
                settings.SetPort('80');
            }
        }
        this.euSign.SetTSPSettings(settings);

        settings = this.euSign.CreateOCSPSettings();
        if (!this.offline) {
            settings.SetUseOCSP(true);
            settings.SetBeforeStore(true);
            settings.SetAddress(this.currentCAServer.ocspAccessPointAddress);
            settings.SetPort(this.currentCAServer.ocspAccessPointPort);
        }
        this.euSign.SetOCSPSettings(settings);

        settings = this.euSign.CreateCMPSettings();
        settings.SetUseCMP(this.useCMP);
        if (this.useCMP) {
            settings.SetAddress(this.currentCAServer.cmpAddress);
            settings.SetPort("80");
        }
        this.euSign.SetCMPSettings(settings);

        settings = this.euSign.CreateLDAPSettings();
        this.euSign.SetLDAPSettings(settings);

        if (this.currentCAServer) {
            this._saveUserLocalSetting(this.storeKeys.CAServerIndex, this.currentCAServer.id);
        }
    }

    updateActiveCertificates(certificates) {
        if (Array.isArray(certificates)) {
            for (var i = 0; i < certificates.length; i++) {
                this.euSign.SaveCertificate(certificates[i]);
                logger.debugLog("Certificate set", certificates[i]);
            }
        } else if (certificates) {
            this.euSign.SaveCertificates(certificates);
            logger.debugLog("Certificates set (single)", certificates);
        }
    }

    setActivePrivateKey(keyData, keyPwd) {
        let resultInfo = {};
        try {
            let ownerInfo = this.euSign.ReadPrivateKeyBinary(keyData, keyPwd);
            logger.debugLog("Pkey read OK.", ownerInfo);
            this.pkSet = true;

            // get cert info by issuer and serial
            resultInfo.rawCert = this.euSign.GetCertificate(ownerInfo.issuer, ownerInfo.serial, false);
            logger.debugLog("Cert got, bytes:", resultInfo.rawCert.length);
            resultInfo.certInfo = this.euSign.ParseCertificate(resultInfo.rawCert);
            logger.debugLog("Cert data parsed:", resultInfo.certInfo);
            //logger.debugLog("SignLib setActivePrivateKey succeeded.");
        } catch (e) {
            logger.errorLog("setActivePrivateKey: exception!", e);
            resultInfo.error = e;
        }
        return resultInfo;
    }

    resetKey() {
        this.euSign.ResetPrivateKey();
    }

    _prepareKey(signParams) {
        var self = this;
        const { privateKeyFile: keyFile, privateKeyPassword: keyPwd, caServer: caServerInfo } = signParams;

        return new Promise(function (resolve, reject) {
            logger.debugLog("SignLib prepareKey called: ", caServerInfo);
            self.currentCAServer = caServerInfo;

            if (self.euSign.IsPrivateKeyReaded()) {
                logger.debugLog('PKey was readed before - clearing.');
                self.resetKey();
            }

            self.activateCurrentCAServer();

            var certificates = [];

            var onKeyRead = function (readedFile) {
                logger.debugLog("Key data readed from file.", readedFile);

                //var keyName = readedFile.file.name; //key name
                var keyData = new Uint8Array(readedFile.data); //key data

                if (self.currentCAServer.certsInKey) certificates = [];
                else if (self.currentCAServer.cmpAddress != "") {
                    try {
                        var cmpAddress = self.currentCAServer.cmpAddress + ":80";
                        var keyInfo = self.euSign.GetKeyInfoBinary(keyData, keyPwd);
                        certificates = self.euSign.GetCertificatesByKeyInfo(keyInfo, [cmpAddress]);
                    } catch (e) {
                        logger.errorLog("Exception on GetKeyInfoBinary/GetCertificatesByKeyInfo!", e);
                        reject(e);
                        return;
                    }
                } else {
                    //logger.errorLog("Неможливо отримати сертифікати ЦСК!");
                    reject('Неможливо отримати сертифікати ЦСК');
                    return;
                }

                try {
                    self.updateActiveCertificates(certificates);
                    let certRawAndInfo = self.setActivePrivateKey(keyData, keyPwd);

                    if (!certRawAndInfo.error) {
                        logger.debugLog("SignLib prepareKey succeeded.");

                        if (self.testMode && self._isLocalStorageAvail()) {
                            self._saveUserLocalSetting('keyData', self.euSign.Base64Encode(readedFile.data));
                            self._saveUserLocalSetting('keyPwd', keyPwd);
                            self._saveUserLocalSetting('caServer', self.currentCAServer, true);
                            logger.warnLog("SignLib is in test mode - data saved to local storage!");
                        }

                        resolve(certRawAndInfo);
                    }
                    else {
                        reject(certRawAndInfo.error);
                    }
                } catch (e) {
                    logger.errorLog("Exception decoding pkey!", e);
                    reject(e);
                }
            }

            self.euSign.ReadFile(keyFile, onKeyRead, function (errorInfo) {
                logger.errorLog("Failed to read key from selected file!", errorInfo);
                reject(errorInfo);
            });
        });
    }

    prepareKey(signParams) {
        return this.isUseSW ? this._SW_prepareKey(signParams) : this._prepareKey(signParams)
    }

    setRuntimeIncludeTimeStamp(newBool) {
        this.euSign.SetRuntimeParameter(cnst.EU_SIGN_INCLUDE_CONTENT_TIME_STAMP_PARAMETER, newBool);
    }

    async _sign(data, isDataHash) {
        var self = this;

        var resultData = {};

        try {
            if (isDataHash) {
                resultData.signature = self.euSign.SignHash(data, true);
            } else {
                //logger.debugLog("Signing data...");
                if (data.length < 100000)
                    resultData.signature = self.euSign.SignData(data, true);
                else {
                    let dataArr = self.euSign.StringToArray(data), i, dataChunk,
                        ctx = self.euSign.CtxCreate(),
                        hashCtx = self.euSign.CtxHashDataBegin(ctx, cnst.EU_CTX_HASH_ALGO_GOST34311, null);
                    for (i = 0; i < dataArr.length; i += 1048576) {
                        dataChunk = dataArr.slice(i, i + 1048576);
                        self.euSign.CtxHashDataContinue(hashCtx, dataChunk);
                    }
                    let hash = self.euSign.CtxHashDataEnd(hashCtx);
                    resultData.signature = self.euSign.SignHash(hash, true);
                }
            }
        }
        catch (e) {
            resultData.error = e;
            logger.errorLog("Exception signing data!", e);
        }
        return resultData;
    }

    async _SW_sign(data, isDataHash) {
        logger.debugLog('SW sign started');
        let resultData = {}
        try {
            if (isDataHash) {
                resultData.signature = await this._SW_promiseApply(this.euSignSW.SignHash, [data]);
            } else {
                if (data.length < 100000) {
                    resultData.signature = await this._SW_promiseApply(this.euSignSW.Sign, [data]);
                } else {
                    let arr = await this._SW_promiseApply(this.euSignSW.StringToBytes, [data])
                    for (let i = 0; i < arr.length; i += 1048576) {
                        await this._SW_promiseApply(this.euSignSW.ContinueSign, [arr.slice(i, i + 1048576)]);
                    }
                    resultData.signature = await this._SW_promiseApply(this.euSignSW.EndSign, []);
                }
            }
        }
        catch (e) {
            resultData.error = e;
            logger.errorLog("Exception SW signing data!", e);
        }
        logger.debugLog('SW sign finished');
        return resultData;
    }

    async sign() {
        return this.isUseSW ? this._SW_sign(...arguments) : this._sign(...arguments);
    }

    testEngine() {
        try {
            logger.warnLog("Testing SignLib engine...");

            if (!this._isLocalStorageAvail()) {
                logger.errorLog("testEngine - no local storage!");
                return false;
            }

            let testCAServers = [{
                "issuerCNs": ["Тестовий ЦСК АТ \"ІІТ\""],
                "address": "ca.iit.com.ua",
                "ocspAccessPointAddress": "ca.iit.com.ua/services/ocsp/",
                "ocspAccessPointPort": "80",
                "cmpAddress": "ca.iit.com.ua",
                "tspAddress": "ca.iit.com.ua",
                "tspAddressPort": "80",
                "directAccess": true
            },
            {
                "issuerCNs": ["Тестовий ЦСК АТ \"ІІТ - 2\""],
                "address": "js.sign.eu.iit.com.ua",
                "ocspAccessPointAddress": "js.sign.eu.iit.com.ua/services/ocsp/",
                "ocspAccessPointPort": "80",
                "cmpAddress": "js.sign.eu.iit.com.ua",
                "tspAddress": "js.sign.eu.iit.com.ua",
                "tspAddressPort": "80",
                "directAccess": true
            }];
            this.setCAServersList(testCAServers, testCAServers[0]);

            const keyData = new Uint8Array(this.euSign.Base64Decode(this._loadUserLocalSetting('keyData', false)));
            const keyPwd = this._loadUserLocalSetting('keyPwd');
            const caServer = this._loadUserLocalSetting('caServer', true);

            if (!keyData || !keyPwd || !caServer) {
                logger.errorLog("testEngine - not enough stored info:", keyData, keyPwd, caServer);
                return false;
            }
            logger.warnLog("testEngine - got stored info:", keyData, keyPwd, caServer);

            this.currentCAServer = caServer;
            this.activateCurrentCAServer();

            let keyAndCertInfo = this.setActivePrivateKey(keyData, keyPwd);

            if (!keyAndCertInfo.error) {
                logger.warnLog("testEngine - prepareKey succeeded.", keyAndCertInfo);
                let data = 'test data';
                let signResult = this.sign(data);
                logger.warnLog("testEngine - test data signed:", signResult);
                let verifyResult = this.euSign.VerifyData(data, signResult.signature);
                logger.warnLog("testEngine - signature verified:", verifyResult);
                return true;
            }
            else {
                logger.errorLog("testEngine - prepareKey failed!", keyAndCertInfo);
                return false;
            }
        } catch (e) {
            logger.errorLog("testEngine - exception decoding pkey!", e);
            return false;
        }
    }

    getLastCAServerId() {
        let sid = this._loadUserLocalSetting(this.storeKeys.CAServerIndex);
        logger.debugLog('getLastCAServerId: ', sid);
        return sid;
    }

    _getSessionStorageItem(name, decodeBase64, protect) {
        try {
            var item = window.sessionStorage.getItem(name);
            if (item == null || item === 'underfined')
                return null;

            if (protect) {
                return this.euSign.UnprotectDataByPassword(
                    item, /*password*/null, /*asString*/!decodeBase64);
            } else {
                if (!decodeBase64)
                    return item;
                else
                    return this.euSign.Base64Decode(item);
            }
        } catch (e) {
            return null;
        }
    }

    _setSessionStorageItem(name, item, protect) {
        try {
            if (protect) {
                var protectedData = this.euSign.ProtectDataByPassword(
                    item, /*password*/null, /*asBase64String*/true);
                window.sessionStorage.setItem(name, protectedData);
            } else {
                if (typeof item === 'string') {
                    window.sessionStorage.setItem(name, item);
                } else {
                    var encoded = this.euSign.Base64Encode(item);
                    window.sessionStorage.setItem(name, encoded);
                }
            }
        } catch (e) {
            return false;
        }
        return true;
    }

    _loadUserLocalSetting(key, useJson) {
        if (this._isLocalStorageAvail()) {
            let storedVal = localStorage.getItem(key);
            if (storedVal !== undefined)
                return (useJson && storedVal !== null) ? JSON.parse(storedVal) : storedVal;
        }
    }

    _isLocalStorageAvail() {
        return (typeof localStorage !== 'undefined' && localStorage);
    }

    _saveUserLocalSetting(key, value, useJson) {
        if (this._isLocalStorageAvail())
            localStorage.setItem(key, (useJson && value !== undefined && value !== null) ? JSON.stringify(value) : value);
    }

    async _SW_promiseApply(func, args) {
        return new Promise((res, rej) => {
            const onError = error => rej(error && error.GetMessage && error.GetErrorCode ? `${error.GetMessage()} (Код помилки: ${error.GetErrorCode()})` : error);
            const onSuccess = data => res(data);
            func.apply(this.euSignSW, [...args, onSuccess, onError])
        })
    }

    _SW_loadCryptoLibrary() {
        return new Promise((res, rej) => {
            logger.debugLog('Load SW library');
            let loader = new IEUSignCP_SW.EndUserLibraryLoader(
                IEUSignCP_SW.EndUserLibraryLoader.LIBRARY_TYPE_DEFAULT, "euSignSW"
            );
            loader.onload = lib => {
                logger.debugLog('SW library loaded');
                this.euSignSW = lib;
                res(lib);
            };
            loader.onerror = err => {
                logger.errorLog(err);
                rej(err);
            };
            loader.load();
        })
    }

    async _SW_initializeCryptoLibrary() {
        await this._SW_promiseApply(this.euSignSW.Initialize, []);
        await this._SW_promiseApply(this.euSignSW.SetRuntimeParameter, [
            this.euSignSW.EU_SAVE_SETTINGS_PARAMETER,
            this.euSignSW.EU_SETTINGS_ID_PROXY
        ]);
        await this._SW_promiseApply(this.euSignSW.SetUIMode, [false]);
        await this._SW_promiseApply(this.euSignSW.SetCharset, ["UTF-16LE"]);
        let settingsFS = this.euSignSW.CreateFileStoreSettings();
        settingsFS.SetPath('');
        settingsFS.SetSaveLoadedCerts(true);
        await this._SW_promiseApply(this.euSignSW.SetFileStoreSettings, [settingsFS]);
        // загружаем корневые сертификаты, если они загружены в обычную библиотеку
        if (this.loadedRootCerts) {
            var certificates = this._getSessionStorageItem(
                'CACertificates', true, false);
            await this._SW_promiseApply(this.euSignSW.SaveCertificates, [certificates]);
        }
        const swLibVer = await this._SW_promiseApply(this.euSignSW.GetVersion, []);
        logger.debugLog('SW Lib version', swLibVer);
    }

    async SW_init() {
        this.isInitSW = false;

        return new Promise((res, rej) => {
            this._SW_loadCryptoLibrary()
                .then(() => this._SW_initializeCryptoLibrary())
                .then(data => {
                    this.isInitSW = true;
                    res(data);
                })
                .catch(error => {
                    this.euSignSW = null;
                    this.isInitSW = false;
                    rej(error)
                });
        })
    }

    async SW_initIfNeeded() {
        return this.isInitSW ? Promise.resolve() : await this.SW_init();
    }

    async SW_getMediaTypesList() {
        logger.debugLog("SW get media types started")
        let arr = [];
        for (let i = 0; true; ++i) {
            let newItem = await this._SW_promiseApply(this.euSignSW.EnumKeyMediaTypes, [i]);
            if (!newItem) break;
            arr.push({ id: i, name: newItem });
        }
        this.mediaTypesList = arr;
        logger.debugLog("SW get media types finished")
        return arr;
    }

    async SW_getMediaDevicesList(typeIndex) {
        logger.debugLog("SW get media device started for media type #" + typeIndex);
        let arr = [];
        for (let i = 0; true; ++i) {
            let newItem = await this._SW_promiseApply(this.euSignSW.EnumKeyMediaDevices, [typeIndex, i]);
            if (!newItem) break;
            arr.push({ id: i, name: newItem });
        }
        this.mediaDevicesList = arr;
        logger.debugLog("SW get media device list finished")
        return arr;
    }

    async _SW_activateCurrentCAServer() {
        let tcpSettings = this.euSignSW.CreateTSPSettings();
        tcpSettings.SetGetStamps(true);
        if (this.currentCAServer.tspAddress !== "") {
            tcpSettings.SetAddress(this.currentCAServer.tspAddress);
            tcpSettings.SetPort(this.currentCAServer.tspAddressPort);
        } else {
            tcpSettings.SetAddress('acskidd.gov.ua');
            tcpSettings.SetPort('80');
        }
        let ocspSettings = this.euSignSW.CreateOCSPSettings();
        ocspSettings.SetUseOCSP(true);
        ocspSettings.SetBeforeStore(true);
        ocspSettings.SetAddress(this.currentCAServer.ocspAccessPointAddress);
        ocspSettings.SetPort(this.currentCAServer.ocspAccessPointPort);

        let cmpSettings = this.euSignSW.CreateCMPSettings();
        cmpSettings.SetUseCMP(this.useCMP);
        if (this.useCMP) {
            cmpSettings.SetAddress(this.currentCAServer.cmpAddress);
            cmpSettings.SetPort("80");
        }
        let ldapSettings = this.euSignSW.CreateLDAPSettings();

        await this._SW_promiseApply(this.euSignSW.SetTSPSettings, [tcpSettings]);
        await this._SW_promiseApply(this.euSignSW.SetOCSPSettings, [ocspSettings]);
        await this._SW_promiseApply(this.euSignSW.SetCMPSettings, [cmpSettings]);
        await this._SW_promiseApply(this.euSignSW.SetLDAPSettings, [ldapSettings]);
    }

    async _SW_prepareKey(signParams) {
        logger.debugLog('SW prepare key started..');
        const { caServer: caServerInfo, privateKeyPassword: keyPwd, mediaTypeId, mediaDeviceId } = signParams;
        this.currentCAServer = caServerInfo;
        this.mediaTypeId = mediaTypeId;
        this.mediaDeviceId = mediaDeviceId;
        const isKeyReaded = await this._SW_promiseApply(this.euSignSW.IsPrivateKeyReaded, []);
        if (isKeyReaded)
            await this._SW_promiseApply(this.euSignSW.ResetPrivateKey, []);
        await this._SW_activateCurrentCAServer();
        // Эти методы можно использовать для всех АЦСК из списка. Но для АЦСК Украина обязательно.
        // обращаю внимание, что GetCertificatesByKeyInfo в отличие от GetCertificatesByKeyInfo получает другие параметры на вход
        // оно получает цепочку сертификатов, а не только свой сертификат
        let keyInfo = await this._SW_promiseApply(this.euSignSW.GetKeyInfoSilently, [mediaTypeId, mediaDeviceId, keyPwd]);
        let ownCertificates = await this._SW_promiseApply(this.euSignSW.GetCertificatesByKeyInfo, [keyInfo, null, null]);
        await this._SW_promiseApply(this.euSignSW.SaveCertificates, [ownCertificates]);
        // само считывание
        await this._SW_promiseApply(this.euSignSW.ReadPrivateKeySilently, [mediaTypeId, mediaDeviceId, keyPwd]);
        // этого бы хватило для GetSerial(), GetIssuer(), GetSubjDRFOCode(), GetSubjEDRPOUCode(), но не для GetExtKeyUsages()
        //let ownerInfo = await this._SW_promiseApply(this.euSignSW.GetPrivateKeyOwnerInfo, []);
        // может это и можно как-то скукожить из ownCertificates, но получим напрямую
        let rawCert = await this._SW_promiseApply(this.euSignSW.GetCertificateByKeyInfo, [keyInfo.privateKeyInfo]);
        let certInfo = await this._SW_promiseApply(this.euSignSW.ParseCertificate, [rawCert]);

        logger.debugLog('SW prepare key finished, certSerial:', certInfo.serial);
        return { rawCert, certInfo };
    }

}

export let SignLib = new NdipitSign({
    testMode: false,
    useGlobalEusignWrapper: false,
    CARequestsProxy: webConfig.caProxyUrl,
    coreEusignUrl: '/globals/signlib/euscp/euscp.js',
    wrapperEusignUrl: '/src/utils/euscp/euscpm.js'
});